import './index.css';
export default {
  name: 'input-checkbox',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: () => null
    },
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      inputValue: null
    }
  },
  created() {
    this.$nextTick(() => {
      this.inputValue = this.$props.value;
    });
  },
  watch: {
    'inputValue'(newVal) {
      this.$emit('input', newVal);
      this.$emit('change', newVal);
    },
    '$props.value'(newVal) {
      if (this.inputValue != newVal)
        this.inputValue = newVal;
    }
  },
  computed: {},
  methods: {}
}
